module.exports = __webpack_public_path__ + "static/img/system.2386b56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/system.png
// module id = nyoC
// module chunks = 1